import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GetAllSamplePOWithLinesDto } from "../models/samplePO/add/getAllSamplePOWithLinesDto";
import { GenericResponseDto } from "../models/generic-response.dto";
import { CopyPOLinesRequestDto } from "../models/samplePO/details/copyPOLinesRequestDto";
import { PurchaseOrderLine } from "../models/samplePO/details/purchaseOrderLine";
import { CopyPOHeaderRequestDto } from "../models/samplePO/details/copyPOHeaderRequestDto";
import { PurchaseOrderLineSummary } from "../models/samplePO/details/samplePOSummaryDto";

@Injectable({
  providedIn: "root",
})
export class SamplepoCopyLinesService {
  private samplepoManagementBaseURL =
    environment.baseUrl + "/SamplePOMangement";

  constructor(private _http: HttpClient) {}

  GetAllSamplePOWithLinesDto(): Observable<
    GenericResponseDto<GetAllSamplePOWithLinesDto[]>
  > {
    return this._http.get<GenericResponseDto<GetAllSamplePOWithLinesDto[]>>(
      this.samplepoManagementBaseURL + "/GetAllSamplePOWithLines"
    );
  }

  copyPOLines(
    payload: CopyPOLinesRequestDto
  ): Observable<GenericResponseDto<PurchaseOrderLine[]>> {
    return this._http.post<GenericResponseDto<PurchaseOrderLine[]>>(
      `${this.samplepoManagementBaseURL}/CopyPOLines`,
      payload
    );
  }

  copyPOHeader(
    payload: CopyPOHeaderRequestDto
  ): Observable<GenericResponseDto<string>> {
    return this._http.post<GenericResponseDto<string>>(
      `${this.samplepoManagementBaseURL}/CopySamplePO`,
      payload
    );
  }

  getAllSamplePOLines(
    purchaseOrderNumber: string
  ): Observable<GenericResponseDto<PurchaseOrderLineSummary[]>> {
    return this._http.get<GenericResponseDto<PurchaseOrderLineSummary[]>>(
      this.samplepoManagementBaseURL +
        "/GetPurchaseOrderLineByPurchaseOrderNumber?purchaseOrderNumber=" +
        purchaseOrderNumber
    );
  }
}
